import React, { useEffect } from "react"

const HashRouterHandler: React.FC = () => {
  useEffect(() => {
    console.log("HashRouterHandler: Current URL:", window.location.href)
    console.log("HashRouterHandler: Current hash:", window.location.hash)
    console.log(
      "HashRouterHandler: Current pathname:",
      window.location.pathname,
    )

    // Check if we have a hash-based route
    const hash = window.location.hash

    if (hash.startsWith("#/signup/")) {
      console.log("HashRouterHandler: Found signup hash route")
      // Extract the token from the hash
      const token = hash.replace("#/signup/", "")
      console.log(
        "HashRouterHandler: Extracted token:",
        token.substring(0, 20) + "...",
      )
      if (token) {
        const newUrl = `/signup/${token}`
        console.log("HashRouterHandler: Redirecting to:", newUrl)
        // Redirect to the new route format
        window.location.href = newUrl
        return
      }
    }

    console.log("HashRouterHandler: No signup hash found, redirecting to login")
    // If no hash or unrecognized hash, redirect to login
    window.location.href = "/login"
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting...</p>
      </div>
    </div>
  )
}

export default HashRouterHandler
